var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exams"},[_c('h1',[_vm._v("Testy:")]),_c('ul',[_c('li',[_c('p',[_vm._v(_vm._s(_vm.shortString('Ciąg fibonacziego', 44)))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }